$shm_hitalama_map_widget_float_rect $shm_hitalama_map_widget_float
	scrollable false
	controls /
		<= Svg $mol_view
			dom_name \svg
			dom_name_space \http://www.w3.org/2000/svg
			attr *
				^
				viewBox \0 0 100 100
				preserveAspectRatio \none
			event *
				pointerdown? <=> content_pointerdown? null
			sub /
				<= Rect $mol_view
					dom_name \rect
					dom_name_space \http://www.w3.org/2000/svg
					attr *
						^
						x \0
						y \0
						width \100
						height \100
						fill <= fill \transparent
						stroke <= stroke \#808080
						stroke-width <= stroke_width \4
						vector-effect \non-scaling-stroke
